"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRequiredIndicationDisplay = exports.getLabelPadding = exports.getInputHeightInPx = void 0;
exports.getInputHeightInPx = function (_a) {
    var compProps = _a.compProps, compLayout = _a.compLayout, isMobileView = _a.isMobileView;
    var inputHeightMobile = compProps.inputHeightMobile, inputHeight = compProps.inputHeight;
    var height = compLayout.height;
    var actualHeight = isMobileView
        ? inputHeightMobile || inputHeight || height
        : inputHeight || height;
    return actualHeight + "px";
};
var labelPaddingLimit = 20;
exports.getLabelPadding = function (compProps) {
    var labelPadding = compProps.labelPadding, textAlignment = compProps.textAlignment, filesAlignment = compProps.filesAlignment;
    var alignment = textAlignment || filesAlignment;
    switch (alignment) {
        case 'left':
            return "0 " + labelPaddingLimit + "px 0 " + labelPadding + "px";
        case 'right':
            return "0 " + labelPadding + "px 0 " + labelPaddingLimit + "px";
        default:
            return undefined;
    }
};
exports.getRequiredIndicationDisplay = function (styleProperties) {
    var txtlblrq = styleProperties.txtlblrq;
    return !txtlblrq || txtlblrq === 'transparent' ? 'none' : 'inline';
};
//# sourceMappingURL=inputUtils.js.map